// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"qN-z","carouselContainer":"rN-z"};